module.exports = __webpack_public_path__ + "static/media/Arcoteccho.5893258b.jpg";